import { gql } from "@apollo/client";

// 어드민: 사장님 공지 전체 목록 (삭제 포함)
export const ADMIN_NOTICES = gql`
  query AdminNotices {
    adminNotices {
      id
      title
      pageUrl
      note
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

// 어드민: 공지 등록
export const CREATE_NOTICE = gql`
  mutation CreateNotice($input: CreateNoticeInput!) {
    createNotice(input: $input) {
      id
      title
      pageUrl
      note
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

// 어드민: 공지 수정
export const UPDATE_NOTICE = gql`
  mutation UpdateNotice($input: UpdateNoticeInput!) {
    updateNotice(input: $input) {
      id
      title
      pageUrl
      note
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

// 어드민: 공지 삭제 (소프트 삭제)
export const DELETE_NOTICE = gql`
  mutation DeleteNotice($id: Int!) {
    deleteNotice(id: $id) {
      ok
      error
    }
  }
`;
